module.exports = __webpack_public_path__ + "img/7d86ee4.jpg";